export default __webpack_public_path__ + "static/MonumentGrotesk-Medium-6b7058ca2785b3837145388353b2d976.eot";